import React from "react";

export default function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section className="relative pt-32 pb-14 lg:pt-40 lg:pb-20 mint-gradient overflow-hidden">
      <div className="pointer-events-none absolute -top-24 right-0 h-80 w-80 rounded-full bg-[#2ED9B8]/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        {eyebrow && (
          <p className="text-xs uppercase tracking-[0.2em] text-[#2ED9B8] font-medium">{eyebrow}</p>
        )}
        <h1 className="mt-3 font-display text-[38px] lg:text-[56px] leading-[1.05] text-foreground max-w-3xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-[16.5px] leading-relaxed text-muted-foreground max-w-2xl">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
